<template>
  <div>
    <Header
      class="yh-header"
      active="/product"
      :product-value="productValue"
    />
    <div style="height: 70px" />
    <ProductCategoryHorizontalSelect
      class="yh-main"
      @selected="onCategoryCode"
    />
    <div
      class="yh-main"
      style="width: 1100px"
    >
      <PopularityRanking />
      <LatestUploading />
    </div>
    <div style="min-height: 70px" />
  </div>
</template>

<script>
// @ is an alias to /src
import ProductCategoryHorizontalSelect from '@/components/ProductCategoryHorizontalSelect.vue'
import PopularityRanking from '@/components/PopularityRanking.vue'
import LatestUploading from '@/components/LatestUploading.vue'
import Header from '@/components/Header'
const options = [{
  value: '1',
  label: '全国直采'
}, {
  value: '2',
  label: '区域直采'
}, {
  value: '3',
  label: '自有品牌'
}, {
  value: '4',
  label: '生鲜进口商品'
}, {
  value: '5',
  label: '一村一品'
}, {
  value: '6',
  label: '1233商品'
}]
export default {
  name: 'Home',
  components: {
    ProductCategoryHorizontalSelect,
    PopularityRanking,
    LatestUploading,
    Header
  },
  data() {
    return {
      productValue: this.$route.query.id,
      tag: options.filter(e => e.value === this.$route.query.id)
    }
  },
  created() {
    this.$store.dispatch('productCategoryPage', {
      packageName: 'product',
      className: 'productCategory',
      methodName: 'retrieve',
      params: {
        numPerPage: 1000,
        tag: this.tag && this.tag[0].label
      }
    })

    this.$store.dispatch('productBasePopularityRanking', {
      packageName: 'product',
      className: 'productBase',
      methodName: 'popularityRanking',
      params: {
        numPerPage: 10,
        orderField: 'viewCount',
        orderDirection: 'desc',
        tag: this.tag && this.tag[0].label
      }
    })

    this.$store.dispatch('productBaseLatestUploading', {
      packageName: 'product',
      className: 'productBase',
      methodName: 'latestUploading',
      params: {
        numPerPage: 10,
        orderField: 'createTime',
        orderDirection: 'desc',
        tag: this.tag && this.tag[0].label
      }
    })

    this.ajax.doPost({
      packageName: 'user',
      className: 'userAnalysis',
      methodName: 'create',
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: '商品百科-首页',
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    })
  },
  methods: {
    onCategoryCode(e) {
      this.$router.push(`/product/list?categoryCode=${e}`)
    }
  }
}
</script>
